import React from 'react';
import Icon from '../../../components/AppIcon';

const WhyFamiliesLoveIt = () => {
  const benefits = [
    { icon: 'Layout', label: 'A more organized system', desc: 'One place for all chores, deadlines, and approvals.', color: '#2dd4bf' },
    { icon: 'MessageCircleOff', label: 'Fewer arguments about chores', desc: 'Expectations are clear before the conversation starts.', color: '#ff6b6b' },
    { icon: 'Repeat', label: 'Better habit-building', desc: 'Consistent routines that kids can own themselves.', color: '#f59e0b' },
    { icon: 'Link', label: 'Clearer responsibility connection', desc: 'Kids understand what happens when chores are done — and when they are not.', color: '#a78bfa' },
  ];

  return (
    <section className="py-24 relative overflow-hidden" style={{background: '#f8f7f4'}}>
      {/* Decorative shapes */}
      <div className="absolute top-0 right-0 w-64 h-64 rounded-full opacity-10 blur-3xl" style={{background: '#2dd4bf'}}></div>
      <div className="absolute bottom-0 left-0 w-48 h-48 rounded-full opacity-10 blur-3xl" style={{background: '#ff6b6b'}}></div>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 mb-6 px-4 py-2 rounded-full text-sm font-bold uppercase tracking-widest" style={{background: '#ff6b6b15', color: '#dc2626', border: '1px solid #ff6b6b30'}}>
            <Icon name="Heart" size={14} />
            Why Families Will Love It
          </div>
          <h2 className="font-heading font-bold leading-tight mb-5" style={{fontSize: 'clamp(2rem, 4vw, 3rem)', color: '#0f1f3d'}}>
            Designed to make parenting easier{' '}
            <span style={{color: '#ff6b6b'}}>and expectations clearer.</span>
          </h2>
          <p className="text-lg max-w-2xl mx-auto" style={{color: '#64748b'}}>
            Instead of vague reminders and frustration, Cynizee gives families a system that makes routines smoother, expectations easier to understand, and accountability more natural.
          </p>
        </div>

        {/* Benefits grid — 2x2 large cards */}
        <div className="grid sm:grid-cols-2 gap-6 mb-12">
          {benefits?.map((benefit, i) => (
            <div
              key={i}
              className="rounded-3xl p-8 flex items-start gap-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl cursor-default"
              style={{background: '#fff', border: '1px solid #e2e8f0'}}
            >
              <div className="w-14 h-14 rounded-2xl flex items-center justify-center flex-shrink-0" style={{background: `${benefit?.color}18`}}>
                <Icon name={benefit?.icon} size={26} style={{color: benefit?.color}} />
              </div>
              <div>
                <h3 className="font-heading font-bold text-lg mb-2" style={{color: '#0f1f3d'}}>{benefit?.label}</h3>
                <p className="leading-relaxed" style={{color: '#64748b'}}>{benefit?.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA banner */}
        <div className="rounded-3xl p-8 sm:p-10 flex flex-col sm:flex-row items-center justify-between gap-6 relative overflow-hidden" style={{background: 'linear-gradient(135deg, #0f1f3d 0%, #1a3a5c 100%)'}}>
          <div className="absolute right-0 top-0 w-48 h-48 rounded-full opacity-10 blur-3xl" style={{background: '#2dd4bf'}}></div>
          <div className="relative z-10 text-center sm:text-left">
            <div className="flex items-center justify-center sm:justify-start gap-3 mb-3">
              <Icon name="Smile" size={24} style={{color: '#2dd4bf'}} />
              <span className="font-heading font-bold text-white text-xl">Built for real family life</span>
            </div>
            <p className="text-lg" style={{color: 'rgba(255,255,255,0.7)'}}>
              Join thousands of families waiting to transform their home routines.
            </p>
          </div>
          <a
            href="#hero"
            className="flex-shrink-0 inline-flex items-center gap-2 font-heading font-bold px-8 py-4 rounded-2xl transition-all duration-300 hover:scale-105 hover:shadow-lg text-white"
            style={{background: 'linear-gradient(135deg, #ff6b6b, #ff4444)'}}
          >
            <Icon name="Bell" size={18} />
            Join the Waitlist
          </a>
        </div>
      </div>
    </section>
  );
};

export default WhyFamiliesLoveIt;
